import React, {FunctionComponent, useEffect} from 'react'
import {ProfileHeader} from '@App/Components/ProfileHeader'
import {Booking} from '@App/Components/Booking'
import {ProfileDetails} from '@App/Components/ProfileDetails'
import {Reviews} from '@App/Components/Reviews'
import {TriangleDivider} from '@App/Components/TriangleDivider'
import {ContactUs} from "@App/Components/ContactUs"
import {Loader} from "@App/Components/Loader"
import {State} from '@App/state'
import {useSelector} from "react-redux";
import {useScrollToTop} from "@App/hooks/useScrollToTop";
import {ServiceFAQs} from "@App/Components/ServiceFAQs";
import {Slot} from "@App/types";
import {ServiceShouldDisplayReviews} from "@App/utils/conditionals/services";
import {FeedbackHint} from "@App/Components/Partials/FeedbackHint";

export type ProfileProps = {
    onSubmit?: (slot: Slot) => void
    embedded?: boolean
}

export const Profile: FunctionComponent<ProfileProps> = ({embedded = false, onSubmit}: ProfileProps) => {

    useScrollToTop()

    const service = useSelector((state: State) => state.orders.service)
    const garage = useSelector((state: State) => state.orders.garage)
    const place = useSelector((state: State) => state.orders.place)
    const organization = useSelector((state: State) => state.orders.organization)



    useEffect(() => {
        const id = crypto.randomUUID();
        {garage?.id && (
            window.sessionStorage.setItem(`correlationID${garage?.id}`, `${id}`)
        )}
    }, [garage])

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'view profile',
            'garage': garage,
            'service': service,
            'location': place,
            'organization': organization
        });
    }, [])

    // redirect back to start if parameters are missing
    // const {redirectOnMissingParams} = useRedirectBack()
    // const location = useLocation()
    // useEffect(() => {
    //     redirectOnMissingParams(['garage', 'service'], location.pathname.substring(0, location.pathname.indexOf('/werkstaetten')))
    // }, [])

    if (!service || !garage) {
        return (
            <div className="h-screen w-screen grid place-items-center">
                <Loader/>
            </div>
        )
    }

    return (
        <div>
            <ProfileHeader garage={garage} displayReviews={ServiceShouldDisplayReviews(service)}/>
            <Booking onSubmit={onSubmit}/>
            <ProfileDetails/>
            {ServiceShouldDisplayReviews(service) && (
                <Reviews/>
            )}

            {!embedded && (
                <section className="bg-neutral-100 pb-10">
                    <TriangleDivider direction={"right"} background={"bg-white"}/>
                    <div className="container md:flex gap-10 mt-10">
                        <div className="w-full md:w-1/2">
                            <ServiceFAQs/>
                        </div>
                        <div className="w-full md:w-1/2">
                            <ContactUs/>
                            <div className={'mt-8'}>
                                <FeedbackHint/>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </div>
    )
}
